import { odata } from '../../conf';

const documentSelect = 'childDocumentId,documentStatus,documentType,fileName,id,isPhysical,isProcessed,link,parentDocumentId,created';

export default {
  async loadDocuments({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('documents')
      .query({ $filter: 'IsDeleted eq false', $select: documentSelect });
    commit('SET_documents', data);
  },
  async LOAD_documents({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('documents')
      .query({ $filter: 'IsDeleted eq false', $select: documentSelect });
    commit('SET_documents', data);
  },
  async LOAD_document({ commit, rootGetters }, id) {
    const i = odata.parseId(id);
    const data = await odata.o(rootGetters)
      .get(`documents(${i})`)
      .query({ $select: documentSelect });
    commit('SET_document', data);
  },
  async LOAD_allDocuments({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('documents/AllDocuments')
      .query();
    commit('SET_allDocuments', data);
  },
  async UPDATE_document({ rootGetters, dispatch }, data) {
    const i = odata.parseId(data.id);
    await odata.o(rootGetters)
      .patch(`documents(${i})`, data)
      .query();
    dispatch('LOAD_documents');
  },
  async UNDELETE_document({ rootGetters }, data) {
    const i = odata.parseId(data.id);
    await odata.o(rootGetters)
      .patch(`documents(${i})`, data)
      .query();
  },
  async DELETE_document({ commit, rootGetters, state }, id) {
    const i = odata.parseId(id);
    await odata.o(rootGetters)
      .delete(`documents(${i})`)
      .query();
    const items = state.documents.filter((item) => item.id !== i);
    commit('SET_documents', items);
  },
};
